module.exports = __webpack_public_path__ + "img/266.3c300019.jpg";